import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

export interface IDeviceNameDialogData {
  deviceId: string;
}

/**
 * Asks for a name for a device which is being moved from the inventory into a company location.
 * Closes with the given name, an empty string when the name is skipped and null when cancelled.
 */
@Component({
    selector: "app-device-name-dialog",
    templateUrl: "./device-name-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [FormsModule, MatDialogModule, TranslateModule]
})
export class DeviceNameDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<DeviceNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDeviceNameDialogData
  ) { }

  name: string = "";

  // Naming the device is optional, empty name moves the device without naming it
  save(): void {
    this.dialogRef.close(this.name.trim());
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
